var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSkills(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25.303 25.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pencil",
    transform: "translate(0.152 0.15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1787",
    "data-name": "Group 1787",
    transform: "translate(0.001 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2998",
    "data-name": "Path 2998",
    d: "M23.507,16.368a5.068,5.068,0,0,0-5.066-1.257l-1.785-1.785,7.8-7.8a1.867,1.867,0,0,0,0-2.641L22.114.547a1.867,1.867,0,0,0-2.641,0l-7.8,7.8L9.89,6.56A5.058,5.058,0,0,0,3.018.442a.488.488,0,0,0-.148.792L5.2,3.564,3.552,5.211,1.223,2.881a.488.488,0,0,0-.792.148A5.058,5.058,0,0,0,6.549,9.9l1.785,1.785L2.361,17.659a.493.493,0,0,0-.119.193L.116,24.268a.488.488,0,0,0,.617.617l6.41-2.124a.588.588,0,0,0,.2-.121l5.973-5.973L15.1,18.452a5.058,5.058,0,0,0,6.872,6.118.488.488,0,0,0,.148-.792l-2.33-2.329L21.437,19.8l2.329,2.329a.488.488,0,0,0,.792-.148,5.058,5.058,0,0,0-1.052-5.615ZM20.164,1.237a.891.891,0,0,1,1.26,0l2.34,2.34a.891.891,0,0,1,0,1.26L22.179,6.422l-3.6-3.6ZM7.024,9a.488.488,0,0,0-.518-.111A4.083,4.083,0,0,1,1.086,4.126l2.12,2.12a.488.488,0,0,0,.691,0L6.235,3.909a.488.488,0,0,0,0-.691L4.114,1.1A4.083,4.083,0,0,1,8.873,6.517a.488.488,0,0,0,.111.518l2,2L9.024,11ZM1.349,23.653l.706-2.131L3.48,22.946ZM4.517,22.6,2.4,20.484,2.92,18.91l3.171,3.171ZM7,21.6,5.542,20.15c-.292-.284-.008,0-.691-.691L3.4,18,17.889,3.512l.039.039,1.415,1.415c1.005,1-.092-.11.691.691l1.455,1.455ZM23.9,20.887l-2.12-2.12a.488.488,0,0,0-.691,0L18.755,21.1a.488.488,0,0,0,0,.691l2.12,2.12A4.083,4.083,0,0,1,16.116,18.5.488.488,0,0,0,16,17.977l-2-2,1.961-1.961,2,2a.488.488,0,0,0,.518.111A4.083,4.083,0,0,1,23.9,20.887Z",
    transform: "translate(-0.001 0)",
    fill: "#5066e7",
    stroke: "#4f66e6",
    strokeWidth: 0.3
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSkills);
export default __webpack_public_path__ + "static/media/icon-skills.a6a799818aab9967b9838c7aa42a7e2b.svg";
export { ForwardRef as ReactComponent };